export function delay(time: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
}
export function getRedirectUrlOutOfOAuthUrl(): string | undefined {
  const urlObj = new URL(window.location.href);
  // try the oauth one first
  let url =
    urlObj.searchParams.get('redirect_uri')?.replace('/callback', '') ||
    undefined;

  // then try our fallback url
  if (!url) {
    url = getRedirectUrlFromParam();
  }
  return url;
}

export function getRedirectUrlFromParam(): string | undefined {
  const urlObj = new URL(window.location.href);
  return urlObj.searchParams.get('redirectUrl') || undefined;
}

export function getMagicLinkEnabled(): boolean {
  // Magic-link login is opt-in: it only shows when `?magicLink=true` is present.
  // The backend appends `magicLink=true` during OAuth authorize only for apps
  // whose redirect URI has a `magicLinkEndpoint` configured, so the form is
  // hidden for applications that haven't populated that field.
  const urlObj = new URL(window.location.href);
  return urlObj.searchParams.get('magicLink') === 'true';
}
export function getRedirectUri(): string | undefined {
  const urlObj = new URL(window.location.href);
  return urlObj.searchParams.get('redirect_uri') || undefined;
}

export function getClientId(): string | undefined {
  const urlObj = new URL(window.location.href);
  return urlObj.searchParams.get('client_id') || undefined;
}

/**
 * Whether the URL carries the full set of OAuth authorize params. Login and
 * signup are only valid inside an OAuth flow (they need a client + redirect to
 * resolve the app); without these params there's no app context, so the caller
 * should bail (Authorize redirects away; Signup shows "Signup not available").
 */
export function hasRequiredOAuthParams(): boolean {
  const params = new URL(window.location.href).searchParams;
  return [
    'response_type',
    'client_id',
    'state',
    'scope',
    'redirect_uri',
    'code_challenge',
    'code_challenge_method',
  ].every((param) => params.has(param));
}

enum Domains {
  onearly = 'onearly.com',
  eirly = 'eirly.health',
  bloodygoodtests = 'bloodygoodtests.com.au',
}

export enum DomainOptions {
  onearly = 'onearly',
  eirly = 'eirly',
  bloodygoodtests = 'bloodygoodtests',
}

interface Theme {
  logo: string;
  logo64: string;
  favicon: string;
  name: string;
}

type ThemeProvider = Record<DomainOptions, Theme>;

const themes: ThemeProvider = {
  [DomainOptions.onearly]: {
    logo: '/img/oe-new.png',
    logo64: '/img/oe-64.png',
    favicon: '/img/oe-tight-favicon.png',
    name: 'On Early',
  },
  [DomainOptions.eirly]: {
    logo: '/img/eirly-logo.png',
    logo64: '/img/eirly-64.png',
    favicon: '/img/eirly-tight-favicon.png',
    name: 'Eirly Health',
  },
  [DomainOptions.bloodygoodtests]: {
    logo: '/img/bgt-new.svg',
    logo64: '/img/bgt-64.png',
    favicon: '/img/tight-favicon.png',
    name: 'Bloody Good Tests',
  },
};

export function getDomainOptionBasedOnDomain() {
  const urlObj = new URL(window.location.href);
  const domain = urlObj.hostname;
  if (domain.includes(Domains.onearly)) {
    return DomainOptions.onearly;
  }
  if (domain.includes(Domains.eirly)) {
    return DomainOptions.eirly;
  }
  return DomainOptions.bloodygoodtests;
}
export function getResetUrl(): string | undefined {
  const urlObj = new URL(window.location.href);
  const resetUrl = urlObj.searchParams.get('resetUrl') || undefined;
  return resetUrl;
}

export function getThemeBasedOnDomain(): Theme {
  const domainOption = getDomainOptionBasedOnDomain();
  return themes[domainOption];
}
